<!-- 饼图 -->
<style lang="stylus" scoped>
.twoWayBar {
  width: 100%;
  height: 284px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="twoWayBar">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '电商企业带动贫困户家庭分析'
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.twoWayBar .main'));

    this.myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: ['家庭人口', '人均扶贫收入', '电商增收(元)'],
        bottom: 10,
        textStyle: {
          color: '#fff',
          fontSize: 16
        }
      },
      grid: {
        top: '3%',
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#00DAEE',
            fontSize: 16
          },
          splitLine: {
            lineStyle: {
              color: '#0092EE'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: ['章*晨', '张*敏', '陈*飞', '陈*泳', '刘*明', '周*轮', '苏*曼', '李*万', '王*说', '顾*网'],
          axisLabel: {
            color: '#00DAEE',
            fontSize: 18
          }
        }
      ],
      series: [
        {
          name: '人均扶贫收入',
          type: 'bar',
          barWidth: 8,
          label: {
            normal: {
              // show: true
              // position: 'inside'
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#FF9E2C'
              }, {
                offset: 0.8,
                color: '#FF4E00'
              }], false)
            }
          },
          data: [2045, 1935, 1902, 1852, 1832, 1789, 1780, 1747, 1734, 1696]
        },
        {
          name: '电商增收(元)',
          type: 'bar',
          barWidth: 8,
          stack: '总量',
          label: {
            normal: {
              // show: true
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#5EB5FF'
              }, {
                offset: 0.8,
                color: '#00DAEE'
              }], false)
            }
          },
          data: [1732, 1712, 1706, 1677, 1606, 1583, 1580, 1487, 1389, 1373]
        },
        {
          name: '家庭人口',
          type: 'bar',
          barWidth: 8,
          stack: '总量',
          label: {
            normal: {
              // show: true
              // position: 'left'
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#C0E450'
              }, {
                offset: 0.8,
                color: '#75CD2D'
              }], false)
            }
          },
          data: [2, 3, 2, 4, 3, 1, 3, 5, 2, 4]
        }
      ]
    });
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?48304ab2